/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-09 15:22:16
 */
/**
 * 全局参数
 */
import uploadObjectConfig from '@/components/NewUpload/config'; // 上传配置
import * as qiniu from 'qiniu-js'; // 七牛云

export const autoPageNum = 1; // 默认分页起始页
export const autopageSize = 30; // 默认分页每页条数

// 富文本上传函数
const uploadFn = async (param) => {
    let fileName = param.file.name;
    let cf = uploadObjectConfig['image'];
    let token = (await cf.getToken({ fileName }) || {}).result;
    if (token) {
        const observer = {
            next(res) {
                param.progress(res.total.percent);
            },
            error(err) {
                param.error({
                    msg: err.message
                });
            },
            complete({ key }) {
                cf.getFile({ key, fileName }).then(({ result } = {}) => {
                    param.success({ url: result });
                });
            }
        };
        const UUID = uuid();
        var dfile = new File([param.file], UUID, { type: param.file.type });
        qiniu.upload(dfile, UUID, token).subscribe(observer);
    }
};

// 生成UUID唯一值
const uuid = () => {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
};

export const braftEditorMedia = {
    uploadFn: uploadFn,
    accepts: {
        image: 'image/png,image/jpeg,image/gif',
        video: 'video/mp4',
        audio: 'audio/mp3'
    },
    pasteImage: true,
    image: true, // 开启图片插入功能
    video: true, // 开启视频插入功能
    audio: true, // 开启音频插入功能
};

// 面包屑显示配置
// setBreadcrumbPaths(this.props.match); // 不带search自动识别面包屑    
// setBreadcrumbPaths({ ...this.props.match, url: this.props.match.url + this.props.history.location.search }); // 带search自动识别面包屑  
export const breadcrumbConfig = [
    {
        title: '个人设置',
        path: '/setting',
        jump: false,
        next: []
    }, {
        title: '用户管理',
        path: '/user',
        jump: false,
        next: [
            {
                title: '会员管理', path: '/member', next: [
                    { title: '会员详情', path: '/member/detail/:id/:isEp' },
                    { title: '企业详情', path: '/member/companyDetail/:userid/:id' },
                    { title: '运费模板', path: '/member/shippingfeeset/:curTabID/:id' },
                ]
            }, {
                title: '经纪人管理', path: '/agent', next: [
                    { title: '经纪人详情', path: '/agent/detail/:id' },
                    { title: '邀请经纪人', path: '/agent/invite' }
                ]
            },
            {
                title: '骑士管理', path: '/rider', next: [
                    { title: '骑士详情', path: '/rider/detail/:id' }
                ]
            }, {
                title: '黑名单', path: '/black', next: [
                    { title: '历史记录', path: '/black/history/:id/:type' }
                ]
            }, {
                title: '微企管理', path: '/microbusinesses', next: [
                    { title: '微企详情', path: '/microbusinesses/companyDetail/:id' },
                    { title: '新建微企', path: '/microbusinesses/create' },
                ]
            }, {
                title: '众包骑士', path: '/crowdsourcing', next: [
                    { title: '新建骑士', path: '/crowdsourcing/addRider' },
                    { title: '骑士详情', path: '/crowdsourcing/detail/:id' },
                ]
            }
        ]
    },
    {
        title: '权限管理',
        path: '/permissions',
        jump: false,
        next: [
            {
                title: '架构管理', path: '/structure'
            },
            {
                title: '员工管理', path: '/employee', next: [
                    { title: '新增员工', path: '/employee/operate/add' },
                    { title: '编辑员工', path: '/employee/operate/edit/:id' }
                ]
            },
            {
                title: '分配权限', path: '/assignauthority'
            },
            {
                title: '菜单配置', path: '/menuconfig'
            },
        ]
    }, {
        title: '帮助中心',
        path: '/companyhelp',
        next: [
            {
                title: '攻略列表', path: '/searchhelp/strategy/:classId', next: [
                    { title: '攻略详情', path: '/strategy/searchhelp/strategy/:classId/:id' },
                    { title: '攻略详情', path: '/strategy/searchhelp/strategy/:classId/:id/:searchKey' }
                ]
            },
            { title: '攻略详情', path: '/strategy/searchhelp/strategy/:classId/:id' },
            { title: '攻略详情', path: '/strategy/searchhelp/strategy/:classId/:id/:searchKey' }
        ]
    },
    {
        title: '客户端管理',
        path: '/client',
        jump: false,
        next: [
            {
                title: '基础管理', path: '/baseset', jump: false, next: [
                    {
                        title: '幻灯片管理', path: '/baseset/slide', next: [
                            {
                                title: '广告管理', path: '/baseset/slide/manage/:sign', next: [
                                    { title: '新增广告', path: '/baseset/slide/manage/:sign/:type' },
                                    { title: '编辑&详情', path: '/baseset/slide/manage/:sign/:type/:id' },
                                ]
                            },
                        ]
                    },
                    {
                        title: '心情管理', path: '/baseset/mood', next: [
                            { title: '编辑&详情', path: '/baseset/mood/:type/:id' },
                        ]
                    }, {
                        title: '物品管理', path: '/baseset/article'
                    }
                ]
            }, {
                title: '帮助中心', path: '/help', jump: false, next: [
                    {
                        title: '攻略分类', path: '/help/strategy', next: [
                            { title: '攻略列表', path: '/help/strategy/article/:id' },
                            { title: '攻略详情', path: '/help/strategy/article/:id/:type' },
                            { title: '攻略详情', path: '/help/strategy/article/:id/:type/:aid' }
                        ]
                    },
                    {
                        title: '初始说明', path: '/help/instruction', next: [
                            { title: '说明详情', path: '/help/instruction/:type/:id/:curTabID' }
                        ]
                    }
                ]
            }, {
                title: '消息推送', path: '/messageMove', next: [
                    { title: '查看详情', path: '/messageMove/detail/:id' },
                    { title: '编辑消息', path: '/messageMove/edit/:id' },
                    { title: '新建消息', path: '/messageMove/add' }
                ]
            }, {
                title: '普惠学院', path: '/school', next: [
                    { title: '课程详情', path: '/school/detail/:id' },
                    { title: '编辑课程', path: '/school/edit/:id' },
                    { title: '新建课程', path: '/school/add' }
                ]
            }
        ]
    }, {
        title: '营销管理',
        path: '/market',
        jump: false,
        next: [
            {
                title: '卡券中心', path: '/cardcentre', next: [
                    { title: '新建卡券', path: '/cardcentre/createinfo' },
                    { title: '卡券编辑', path: '/cardcentre/editorinfo/:id' },
                    { title: '卡券详情', path: '/cardcentre/detailinfo/:id' }
                ]
            },
            {
                title: '事件触达', path: '/eventtouch', next: [
                    { title: '新建事件', path: '/eventtouch/createinfo' },
                    { title: '事件编辑', path: '/eventtouch/editorinfo/:id' },
                    { title: '事件详情', path: '/eventtouch/detailinfo/:id' }
                ]
            }, {
                title: '积分规则', path: '/accumulaterule', next: [
                    { title: '设置积分产生策略', path: '/accumulaterule/setting' }
                ]
            }
        ]
    }, {
        title: '合同管理',
        path: '/contract',
        jump: false,
        next: [
            {
                title: '合同列表', path: '/contractlist', next: [
                    {
                        title: '管理', path: '/contractlist/contractlistment/:id', next: [
                            { title: '新建协议', path: '/contractlist/createinfo/:code' },
                            { title: '编辑协议', path: '/contractlist/editorinfo/:id/:code' },
                            { title: '协议详情', path: '/contractlist/detailinfo/:id/:code' }
                        ]
                    }
                ]
            }, {
                title: '合同模板', path: '/templatetrac', next: [
                    { title: '已签署合同', path: '/templatetrac/list/:id' }
                ]
            }
        ]
    }, {
        title: '市场管理',
        path: '/operation',
        jump: false,
        next: [
            {
                title: '运营公司', path: '/company', next: [
                    { title: '运营公司详情', path: '/company/detail/:id' },
                    { title: '创建运营公司', path: '/company/create' },
                    { title: '编辑运营公司', path: '/company/edit/:id' },
                    { title: '变更运营公司', path: '/company/change/:id' },
                ]
            }, {
                title: '增值服务', path: '/service', next: [
                    { title: '增值服务详情', path: '/service/detail/:id' },
                    { title: '编辑增值服务', path: '/service/edit/:id' }
                ]
            },
            {
                title: '城市管理', path: '/city'
            },
            {
                title: '配送站点', path: '/transportCompany', next: [
                    { title: '站点详情', path: '/transportCompany/detail/:id' },
                ]
            }
        ]
    }, {
        title: '审核管理',
        path: '/audit',
        jump: false,
        next: [
            {
                title: '审核列表', path: '/list', next: [
                    { title: '经纪人详情', path: '/list/brokerinfo/:companyId/:id' },
                    { title: '审核经纪人', path: '/list/auditbroker/:companyId/:id' },
                    { title: '运营公司详情', path: '/list/operatorinfo/:companyId/:id' },
                    { title: '审核运营公司', path: '/list/auditoperator/:companyId/:id' },
                ]
            },
            { title: '头像昵称', path: '/picturenickname' },
            { title: '健康证审核', path: '/healthcertificate' },
        ]
    },
    {
        title: '订单管理',
        path: '/order',
        jump: false,
        next: [
            {
                title: '保险单', path: '/insuranceorder', next: [
                    { title: '查看详情', path: '/insuranceorder/orderdetail/:id' }
                ]
            },
            {
                title: '增值服务订单', path: '/serviceorder', next: [
                    { title: '查看详情', path: '/serviceorder/orderdetail/:id' }
                ]
            }, {
                title: '配送订单', path: '/distributionorder', next: [
                    { title: '骑士列表', path: '/distributionorder/orderdetail/:id/:lat/:lng/:userId' },
                    { title: '查看详情', path: '/distributionorder/orderdetail/:id' },
                    { title: '查看详情', path: '/distributionorder/multiorderdetail/:id' },
                    { title: '订单日志', path: '/distributionorder/orderhistory/:id' }
                ]
            },
            { title: '虚拟通信记录', path: '/virtualno' },
            {
                title: '微企配送订单', path: '/microshippingorder', next: [
                    { title: '查看详情', path: '/microshippingorder/orderdetail/:id' },
                    { title: '订单日志', path: '/microshippingorder/orderhistory/:id' }
                ]
            },
        ]
    },
    {
        title: '售后管理',
        path: '/aftersale',
        jump: false,
        next: [
            {
                title: '配送投诉', path: '/deliverycomplain', next: [
                    { title: '查看详情', path: '/deliverycomplain/orderdetail/:id' },
                    { title: '投诉处理', path: '/deliverycomplain/handle/:id' }
                ]
            }, {
                title: '配送订单指派', path: '/distributionorderassign', next: [
                    { title: '骑士列表', path: '/distributionorderassign/orderdetail/:id/:lat/:lng/:userId' },
                    { title: '订单日志', path: '/distributionorderassign/orderhistory/:id' }
                ]
            }, {
                title: '评价管理', path: '/deliveryeval', next: [
                    { title: '查看详情', path: '/deliveryeval/orderdetail/:id' },
                ]
            },
            {
                title: '评价管理', path: '/deliveryeval/:tel', next: [
                    { title: '查看详情', path: '/deliveryeval/orderdetail/:id' },
                ]
            },

            {
                title: '罚单列表', path: '/deliveryticket', next: [
                    { title: '查看详情', path: '/deliveryticket/detail/:id' },
                    { title: '处理', path: '/deliveryticket/appeal/:id' },
                ]
            },
            {
                title: '罚单列表', path: '/deliveryticket/:tel', next: [
                    { title: '查看详情', path: '/deliveryticket/detail/:id' },
                    { title: '处理', path: '/deliveryticket/appeal/:id' },
                ]
            },
            {
                title: '意见反馈', path: '/suggestions'
            }
        ]
    }, {
        title: '财务管理',
        path: '/finance',
        jump: false,
        next: [
            {
                title: '平台钱包账户', path: '/platformwallet'
            },
            {
                title: '退款列表', path: '/refund'
            },
            {
                title: '运营公司对账单', path: '/accountstatement', next: [
                    { title: '运营中心对账单详情', path: '/accountstatement/detail/:id' },
                ]
            },
            {
                title: '站点对账单', path: '/microtransportstatements', next: [
                    { title: '对账单详情', path: '/microtransportstatements/detail/:settleMode/:reconId' },
                ]
            },
            {
                title: '账户流水', path: '/accountflow'
            },
            {
                title: '银行交易明细', path: '/banktransaction'
            },
            {
                title: '付款管理', path: '/paymanage', next: [
                    { title: '退押金详情', path: '/paymanage/refundDepositDetail/:id' },
                    { title: '付款详情', path: '/paymanage/:type/:id/:curTabID' },
                ]
            },
            {
                title: '收款管理', path: '/collectionmanage', next: [
                    { title: '收款详情', path: '/collectionmanage/detail/:id' },
                ]
            },
            {
                title: '平台补贴', path: '/platformsubsidy'
            },
            {
                title: '企业会员预付款记录', path: '/enterpriserecharge'
            },
            {
                title: '临时税务登记证', path: '/provisionaltaxregister', next: [
                    { title: '登记证详情', path: '/provisionaltaxregister/detail/:id' },
                ]
            },
            {
                title: '企业对账单', path: '/enterprisereconciliation', next: [
                    { title: '对账单详情', path: '/enterprisereconciliation/reconciliation/detail/:id' },
                    { title: '企业详情', path: '/enterprisereconciliation/reconciliationcycle/detail/:userid/:id' },
                ]
            }, {
                title: '微企对账单', path: '/microbusinessesstatements', next: [
                    { title: '对账单详情', path: '/microbusinessesstatements/detail/:reconId' },
                ]
            }, {
                title: '微企订单导入', path: '/microimportorder'
            }, {
                title: '微企收款管理', path: '/microcollectionmanage', next: [
                    { title: '收款单详情', path: '/microcollectionmanage/detail/:id' },
                ]
            }, {
                title: '站点钱包', path: '/transportCompanyWallet', next: [
                    { title: '账户明细', path: '/transportCompanyWallet/accountDetail/:id' },
                    { title: '提现记录', path: '/transportCompanyWallet/cashRecord/:id' },
                ]
            }
        ]
    }, {
        title: '系统管理',
        path: '/system',
        jump: false,
        next: [
            { title: '参数设置', path: '/parameter' },
            {
                title: '配送费设置', path: '/shippingfeeset', next: [
                    { title: '新建配送费', path: '/shippingfeeset/createfee/:curTabID' },
                    { title: '编辑配送费', path: '/shippingfeeset/editfee/:id/:curTabID' }
                ]
            },
            {
                title: '骑手等级', path: '/riderlevelset', next: [
                    { title: '添加骑手等级', path: '/riderlevelset/createlevel' },
                    { title: '编辑骑手等级', path: '/riderlevelset/editlevel/:id' }
                ]
            },
            {
                title: '版本管理', path: '/versions', next: [
                    { title: '新建版本', path: '/versions/create' },
                    { title: '编辑版本', path: '/versions/edit/:id' },
                    { title: '版本详情', path: '/versions/detail/:id' }
                ]
            },
            {
                title: '计费比例设置', path: '/rate', next: [
                    { title: '历史记录', path: '/rate/historical/:id' },
                ]
            },
            { title: '基础详情', path: '/baseinfo' },
            { title: '经营资质', path: '/qualificationinfo' },
            { title: '运营区域', path: '/areainfo' },
            { title: '财务信息', path: '/financialinfo' },
            { title: '反馈类型', path: '/feedbacktype' },
            { title: '风控管理', path: '/riskcontrol' },
            { title: '财务设置', path: '/financialset' },
            { title: '攻略分类字典', path: '/dictionaries' },
            {
                title: '运营规则', path: '/operatingrule', next: [
                    { title: '新建规则', path: '/operatingrule/createInfo' },
                    { title: '编辑规则', path: '/operatingrule/editInfo/:id' }
                ]
            },
            { title: '敏感词库', path: '/sensitiveword' },
        ]
    },
    {
        title: '报表管理',
        path: '/report',
        jump: false,
        next: [
            {
                title: '报表模版管理', path: '/report/reporttemplate', next: [
                    { title: '模版详情', path: '/report/reporttemplate/detail/:id' },
                ]
            },
            {
                title: '报表生成记录', path: '/report/reportrecord', next: [
                    { title: '生成报表', path: '/report/reportrecord/generate' },
                ]
            }
        ]
    }
];
